/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const actions = {
  async roles({}, payload) {
    const url = `/roles?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  async fetch({}, payload) {
    const url = `/operator-${payload.jenis ?? 'loket'}?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  async searchAkun({}, payload) {
    const url = `/akun/cari?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  async detail({}, payload) {
    const url = `/operator-${payload.jenis}/${payload.id}`;
    return await http.get(url).then(({ data }) => data);
  },

  create({}, payload) {
    const url = `/operator-${payload.jenis}`;
    return http.post(url, payload.params);
  },

  updateRoles({}, payload) {
    const url = `/operator/${payload.id}/roles`;
    return http.post(url, payload.params);
  },

  update({}, payload) {
    const url = `/akun/${payload.id}`;
    return http.patch(url, payload.params);
  },

  status({}, payload) {
    const url = `/operator-${payload.jenis}/${payload.id}/${payload.status}`;
    return http.post(url);
  },

  delete({}, payload) {
    const url = `/operator-${payload.jenis}/${payload.id}`;
    return http.delete(url);
  },

  reset({}, payload) {
    const url = `/operator-${payload.jenis}/${payload.id}/reset`;
    return http.post(url);
  },
};
